export default "__VITE_ASSET__YyGRkijJ__"